<script>
import {GET_ANSWER_STUDENT, MAKE_EXAM_SPEAKING} from "@/core/services/store/test/testInput.module";
import {TestModel} from "@/view/pages/test-input/models/test_model";
import CriteriaBlock from "@/view/pages/test-input/components/ComponentMarkTheExam/CriteriaBlock.vue";
import { WritingCriteria} from "@/core/option/newTestInputOption";
import {PLAGIARISM_RATE} from "@/core/option/testInputOption";
import CheckPlagiarism from "@/view/pages/test-input/components/ComponentMarkTheExam/CheckPlagiarism.vue";
import ModalConfirmedPlagiarism
  from "@/view/pages/test-input/components/ComponentMarkTheExam/ModalConfirmedPlagiarism.vue";
import router from "@/router";

export default {
  name: "NewMarkWriting",
  components: {ModalConfirmedPlagiarism, CheckPlagiarism, CriteriaBlock},
  props: ['aiResult'],
  watch: {
    aiResult: {
      deep: true,
      async handler(newVal) {
        const loading = this.$loading({
          lock: true,
          text: 'Đang tải dữ liệu...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        await this.getAnswerStudent();
        
        if (newVal?.length > 0 && newVal) {
          const resultTask = newVal.find(r => r.course_type === 'Basic') || newVal[0] || newVal.find(r => r.course_type === 'HighTask1'); 
          this.markStatus = this.checkIsAIMark(resultTask);
          
          this.writingCriteria?.forEach((criteria) => {
            if (resultTask) {
              const criteriaResult = resultTask?.score_breakdown?.find((c) => c.key === criteria.apiName);
              if (criteriaResult) {
                this.$set(criteria, 'specificComment', criteriaResult.comment);
                this.$set(criteria, 'isAIMark', this.checkIsAIMark(resultTask));
                this.$set(criteria, 'point', criteria.isAIMark ? criteriaResult.point : null);
              }
            }
          });
        }
        loading.close();
      },
      immediate: true
    }
  },
  data(){
    return{
      topic:'',
      dataTests: [],
      writingCriteria: JSON.parse(JSON.stringify(WritingCriteria)),
      PLAGIARISM_RATE:PLAGIARISM_RATE,
      plagiarismData:{
        isPlagiarism:false,
        plagiarismRate: null,
        plagiarismComment:'',
      },
      step: 0,
      markStatus: false
    }
  },
  mounted() {
    
  },
  methods:{
    async getAnswerStudent() {
      let test_input_schedule_id = this.$route.params.id
      return this.$store.dispatch(GET_ANSWER_STUDENT, test_input_schedule_id).then((data) => {
        if (!data.error) {
          this.topic = data?.data?.topic
          this.dataTests = data?.data?.userAnswers.flat().filter(item => item.answers.length > 0).map((element) => {
            return new TestModel(element.description, element.answers.reduce((a, b) => a + b))
          })
        }
      })
    },
   async confirm(isZeroPoint = false){
      if(isZeroPoint){
        this.writingCriteria.forEach((criteria)=>{
          criteria.point = 0
          criteria.specificComment = ''
        })
      }
      let data = {
        type: "writing",
        criterias: this.writingCriteria.map((criteria)=>{
          return {
            key: criteria.apiName,
            point: criteria.point,
            comment: criteria.specificComment,
            comment_auto: criteria?.pointList?.find(point => point.band === criteria.point)?.eComment??'',
            v_comment_auto:criteria?.pointList?.find(point => point.band === criteria.point)?.vComment??''
          }
        }),
        plagiarism:{
          type_of_plagiarism:this.plagiarismData.isPlagiarism?this.plagiarismData.plagiarismRate:0,
          description_of_plagiarism: this.plagiarismData.isPlagiarism?this.plagiarismData.plagiarismComment:''
        },
        version: 2
      }
      let test_input_schedule_id = this.$route.params.id
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      await this.$store.dispatch(MAKE_EXAM_SPEAKING, {id: test_input_schedule_id, data: data}).then(()=>{
        this.$message.success('Chấm Writing thành công');
        router.push({name: 'task-details', params: {id: test_input_schedule_id}})
      }).finally(() => {
        loading.close();
      })

    },
    markPlagiarism(){
      this.$bvModal.show("Modal-Confirmed-Plagiarism")
    },
    nextStep(){
      this.step = 1
    },
    checkIsAIMark(result){
      return result?.confidence?.rawScore >= 8 && result?.final_score > 4
    }
  },
  computed:{
    countWords() {
      const words = this.dataTests[0]?.answerOfUser?.trim().split(/\s+/);
      if(words){
        return words.length;
      }
      return 0
    }
  }

}
</script>

<template>
  <div class="row">
    <div class="col-4 " style="height: 650px; overflow-y: scroll">
     <CheckPlagiarism  v-if="step === 0" :PLAGIARISM_RATE="PLAGIARISM_RATE" :plagiarismData="plagiarismData" @markPlagiarism="markPlagiarism()" @nextStep="nextStep()"></CheckPlagiarism>
      <div v-else>
        <!-- Badge hiển thị ai là người chấm -->
        <div class="mb-4 d-flex justify-content-start">
          <span v-if="markStatus" class="badge badge-success text-white" style="background-color: #28a745; font-size: 11px; padding: 4px 8px; border-radius: 12px; font-weight: 500;">
            ✨ AI chấm
          </span>
          <span v-else class="badge badge-secondary" style="font-size: 11px; padding: 4px 8px; border-radius: 12px; font-weight: 500;">
            👨‍🏫 Admin chấm
          </span>
        </div>
        <ValidationObserver v-slot="{ handleSubmit }" ref="form">
          <form @submit.prevent>
            <section >
              <div v-for="(criterion, index) in writingCriteria" :key="index" class="mb-6">
                <CriteriaBlock :criterion="criterion"></CriteriaBlock>
              </div>
            </section>
            <div class="d-flex justify-content-end mt-6">
              <button type="button" class="btn btn-secondary mr-4"  @click="step = 0">Quay lại</button>
              <button type="button" class="btn btn-primary" @click="handleSubmit(confirm)">Hoàn thành</button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
    <div class="col-8 ">
      <div class="pl-8">
        <div style="background-color: #F8F8F8;border-radius: 3px" class="p-4">
          <h4 style="font-weight: bold;font-size: 14px" >Đề bài</h4>
          <div style="background-color: white;color: #4F4F4F" class="px-3 py-4 mt-4">
            <p style="font-weight: 400;" v-html="topic"></p>
          </div>
        </div>
        <div style="background-color: #F8F8F8;border-radius: 3px" class="p-4 mt-5">
          <h4 style="font-weight: bold;font-size: 14px" >Bài làm của học viên</h4>
          <div style="background-color: white;color: #4F4F4F" class="px-3 py-4 mt-4 content_test">
            <p style="font-weight: 400;white-space:pre-line">{{dataTests[0]?.answerOfUser}}</p>
          </div>
          <p style="font-weight: normal;font-size: 13px" class="mb-0 mt-3">Số từ: <span>{{countWords}}</span></p>
        </div>
      </div>
    </div>
    <ModalConfirmedPlagiarism @submit="confirm(true)"></ModalConfirmedPlagiarism>
  </div>
</template>

<style scoped>

</style>